import { CartFragment } from '../../graphql/magento'
import { UserCategory } from '../../utils/userClaims'

export const truemedAllowedUserCategories: UserCategory[] = ['patient', 'employee']

export const truemedIneligibleSkus: string[] = ['BLNDBT', 'PBSSPM', 'NOSTRIP', 'PBSLEM', 'PERM60']

export const isTruemedAllowedUserCategory = (
  isAuthenticated: boolean,
  category: UserCategory | undefined,
): boolean => {
  if (!isAuthenticated || !category) {
    return true
  }
  return truemedAllowedUserCategories.includes(category)
}

export const isSkuEligibleForTruemed = (sku: string): boolean =>
  !truemedIneligibleSkus.includes(sku)

/**
 * Checks if the cart ONLY contains SKUs that are not eligible for TrueMed payment
 * (if cart has other products besides the not eligible ones, TrueMed should be available)
 */
export const isCartItemsEligibleForTruemed = (cartItems: CartFragment['items']): boolean => {
  if (!cartItems || cartItems.length === 0) {
    return true
  }
  return cartItems.some((item) => !!item?.product.sku && isSkuEligibleForTruemed(item.product.sku))
}
